module.exports = __webpack_public_path__ + "static/img/evaluaciones.a0d12a88.png";